const getConfigValue = (name: string) => {
  return import.meta.env[name] || (window as any).VITE_APP_ENV[name];
};

export default getConfigValue;
